<template>
  <div>
    <video-player class="video-player vjs-custom-skin vjs-big-play-centered" ref="videoPlayer" :options="playerOptions" @ended="onPlayerEnded($event)" @pause="onPlayerPause($event)" @play="onPlayerPlay($event)"></video-player>
    <!-- <el-button @click="screenshot">截图 </el-button> -->
  </div>
</template>

<script type="text/ecmascript-6">
// import { uploadFile } from "@/api/public";
export default {
  name: "CusVideo",
  components: {},
  data() {
    return {
      // 视频播放
      playerOptions: {
        overNative: false,
        autoplay: true,
        controls: true,
        preload: "auto",
        fluid: true,
        techOrder: [/* "flash", */ "html5"],
        sourceOrder: true,
        flash: {
          hls: {
            withCredentials: false,
          },
        },
        html5: {
          hls: {
            withCredentials: false,
          },
        },
        sources: [
          {
            type: "video/mp4",
            src: "rtmp://184.72.239.149/vod/&mp4:BigBuckBunny_115k.mov",
          },
        ],
        poster: "", //你的封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          // timeDivider: false,
          durationDisplay: true,
          // remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
          // progressControl: false, //进度条
        },
      },
    };
  },
  props: {
    videourl: {
      type: String,
      default: "",
    },
    filetype: {
      type: String,
      default: "",
    },
    isNeedMethods: {
      type: Boolean,
      default: false,
    },
    isNeedImage: {
      type: Boolean,
      default: false,
    },
    isNeedUpload: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    videourl(val, oldval) {
      this.playerOptions.sources[0].src = val;
      this.playerOptions.autoplay = true;
    },
    filetype(val, oldval) {
      this.playerOptions.sources[0].type = val;
      this.playerOptions.autoplay = true;
    },
  },
  computed: {},
  methods: {
    /* 播放状态回调 */
    /*
     * @play
     * @pause
     * @ended
     * @waiting
     * @playing
     * @loadeddata
     * @timeupdate
     * @statechanged
     * @ready
     */
    //播放结束回调
    onPlayerEnded(event) {
      if (!this.isNeedMethods) {
        return;
      }
      this.$emit("playEnd");
    },
    //暂停
    onPlayerPause(event) {
      if (!this.isNeedMethods) {
        return;
      }
      this.$emit("playPause");
    },
    //播放
    onPlayerPlay(event) {
      if (!this.isNeedMethods) {
        return;
      }
      this.$emit("playPlay");
    },
    getBase64Image(img) {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, img.width, img.height);
      var ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
      var dataURL = canvas.toDataURL("image/" + ext);
      return dataURL;
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: "image/jpg" });
    },
    screenshot() {
      if (!this.isNeedImage) {
        return;
      }
      let self = this;
      var video = $("video");
      var canvas = document.createElement("canvas");
      canvas.width = video[0].videoWidth;
      canvas.height = video[0].videoHeight;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(video[0], 0, 0, canvas.width, canvas.height);
      let image = new Image();
      image.src = canvas.toDataURL("image/png");
      image.setAttribute("crossOrigin", "anonymous");

      image.onload = function () {
        var base64 = self.getBase64Image(image);
        var file = self.dataURLtoFile(base64, "123456789aaaaaaaaa.jpg");
        if (!self.isNeedUpload) {
          self.sendImge(file, base64);
        } else {
          let fd = new FormData();
          fd.append("file", file);
          let config = {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          };
          uploadFile(fd, config).then((res) => {
            if (res.success) {
              window.open(window.BASE_API + res.data.fullpath);
            }
          });
        }
      };
    },
    sendImge(file, base64) {
      this.$emit("getImgeFile", { file, base64 });
    },
  },
  //页面加载时候
  created() {
    this.playerOptions.sources[0].type = this.filetype;
    this.playerOptions.sources[0].src = this.videourl;
    /* this.playerOptions.sources[0].src =
      "http://222.77.181.149:9001/annex/C88B8B1144B74442826783965D41861A.mp4";
    this.playerOptions.sources[0].type = "video/mp4"; */
    this.playerOptions.autoplay = true;
  },
};
</script>
<style >
.vjs-fluid {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// CusVideo.vue?2ffc3f8f